import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Parents = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />
      <Sidebar isOpen={open} close={() => setOpen(false)} />
      <main className="page-wrapper">
        {/* HERO */}
        <div className="about-hero">
          <div className="about-overlay">

            <h1>PARENTS</h1>
            <Breadcrumb />

          </div>

        </div>

        <div className="container contact-page">

          <div className="vision-card admission-card">

            <h2 className="admission-title">
              Parent Teacher’s Meet
            </h2>

            <p>
              PTM meetings are conducted regularly to discuss
              academic progress, attendance, discipline and
              overall development of students.
            </p>
          </div>

        </div>
      </main>
      <Footer />
    </>
  );
};

export default Parents;